import BookingApplication from '@/components/bookings/BookingApplication.vue'
import DealApplicationProperty from  '@/components/bookings/deals/DealApplicationProperty.vue'
import DealApplicationLessor from  '@/components/bookings/deals/DealApplicationLessor.vue'
import DealApplicationTerms from  '@/components/bookings/deals/DealApplicationTerms.vue'
import DealApplicationLessee from  '@/components/bookings/deals/DealApplicationLessee.vue'
import DealApplicationDecision from  '@/components/bookings/deals/DealApplicationDecision.vue'
import HeaderBlank from '@/components/HeaderBlank.vue'
import Header from '@/components/Header.vue'
import { getCurrentFirebaseUser } from '@/platform/auth/services/authService.js'

export default [
    {
        path: '/booking/application',
        name: 'bookingApplication',
        components: {
          header: HeaderBlank,
          content: BookingApplication
        },
        props: {
          header: true,
          content: true
        },
        beforeEnter(to, from, next) {
          let user = getCurrentFirebaseUser()
          if (user && !user.isAnonymous) {
            next()
          } else {
            next('/login')
          }
        }
      },
      {
        path: '/application/property',
        name: 'dealApplicationProperty',
        components: {
          header: Header,
          content: DealApplicationProperty
        },
        props: {
          header: true,
          content: true
        },
        beforeEnter(to, from, next) {
          if (sessionStorage.getItem('signedIn')) {
            next()
          } else {
            next('/login')
          }
        }
      },
      {
        path: '/application/lessor',
        name: 'dealApplicationLessor',
        components: {
          header: Header,
          content: DealApplicationLessor
        },
        props: {
          header: true,
          content: true
        },
        beforeEnter(to, from, next) {
          if (sessionStorage.getItem('signedIn')) {
            if (from.name == "manage" || from.name == 'dealApplicationProperty' || from.name == 'dealApplicationTerms') {
              next()
            } else {
              next('/deals')
            }
          } else {
            next('/login')
          }
        }
      },
      {
        path: '/application/terms',
        name: 'dealApplicationTerms',
        components: {
          header: Header,
          content: DealApplicationTerms
        },
        props: {
          header: true,
          content: true
        },
        beforeEnter(to, from, next) {
          if (sessionStorage.getItem('signedIn')) {
            if (from.name == 'dealApplicationLessor') {
              next()
            } else {
              next('/deals')
            }
          } else {
            next('/login')
          }
        }
      },
      {
        path: '/application/decision',
        name: 'dealApplicationDecision',
        components: {
          header: Header,
          content: DealApplicationDecision
        },
        props: {
          header: true,
          content: true
        },
        beforeEnter(to, from, next) {
          if (sessionStorage.getItem('signedIn')) {
            if (from.name == 'dealApplicationTerms') {
              next()
            } else {
              next('/deals')
            }
          } else {
            next('/login')
          }
        }
      },
      {
        path: '/application/lessee',
        name: 'dealApplicationLessee',
        components: {
          header: Header,
          content: DealApplicationLessee
        },
        props: {
          header: true,
          content: true
        }
      },
]


// WEBPACK FOOTER //
// ./src/router/application/index.js